import React, { useEffect, useState } from 'react'
import logo from 'assets/img/logo.svg'
import { Outlet, Navigate } from 'react-router-dom';
import { SideImage, Icon } from 'components'
import { useAuth } from 'contexts/AuthContext'
import { useTranslation } from 'react-i18next'
import cn from 'classnames'; 


export const AuthLayout = () => {
    const { t } = useTranslation();
    const { user } = useAuth();
    const year = new Date().getFullYear();
    const [fadeIn, setFadeIn] = useState(false);
    
    useEffect(() => {
        setTimeout(() => {
            setFadeIn(true);
        }, 500);
    }, [])


    return (
        user ? <Navigate to="/" /> :
            <div className="flex">
                <div className="flex flex-col justify-between py-5 px-14 h-screen w-1/3">
                    <div className={cn("logo enter-y", {fadeIn})}>
                        <img src={logo} alt="" />
                    </div>
                    <div>
                        <Outlet />
                    </div>
                    <p className={cn("mt-20 text-xs c-grey enter-y delay-500", {fadeIn})}>{t('copyRight', { value: year })}</p>
                </div>
                <SideImage className="w-2/3" />
            </div>
    )
}
